<template>
    <div class="underlying-child-content">
        <div class="line"></div>
        <le-pagview ref="underlyingPropertyList" @setData="setTableData" :pageParam="pageParam" v-if="pageParam">
            <el-table :data="tabledata">
                <el-table-column label="操作" prop="operateType">
                    <template slot-scope="{ row }">
                        {{ row.operateType | initDic(operateTypeDic) }}
                    </template>
                </el-table-column>
                <el-table-column label="变更内容" prop="content">
                    <template slot-scope="{ row }">
                        <el-button type="text" @click="showChangeContent(row)">详情</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="操作人" prop="orderId">
                    <template slot-scope="{ row }">
                        <span>{{ row.updateUserName || '-' }} {{ row.updateUserPhone || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作时间" prop="updateTime"></el-table-column>
            </el-table>
        </le-pagview>
        <el-dialog
            title="变更内容详情"
            :visible.sync="dialogVisible"
            :close-on-click-modal='false'
            :close-on-press-escape='false'
            width="1000px">
            <div class="formContent">
                <el-table :data="changeTableData">
                    <el-table-column label="">
                        <template slot-scope="{ row }">
                            <span>{{ row.changeItemName || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="description" label="修改前">
                        <template slot-scope="{ row }">
                            <span v-if="row.keyVal != 'investIncomeDetails'">{{ row.oldVal || '-' }}</span>
                            <div v-else class="a-flex-cfsfs a-w-100" style="align-items: flex-start">
                                <span v-for="(item,index) in row.oldVal" :key="index">{{ item.companyName }}，比例：{{ (item.ratio * 100).toFixed(2) }}%（{{ item.type==1?'回收后':'回收前' }}）</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="description" label="修改后">
                        <template slot-scope="{ row }">
                            <span v-if="row.keyVal != 'investIncomeDetails'">{{ row.newVal || '-' }}</span>
                            <div v-else class="a-flex-cfsfs a-w-100" style="align-items: flex-start">
                                <span v-for="(item,index) in row.newVal" :key="index">{{ item.companyName }}，比例：{{ (item.ratio * 100).toFixed(2) }}%（{{ item.type==1?'回收后':'回收前' }}）</span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer">
                <el-button type="primary" @click="dialogVisible = false">关闭</el-button>
            </div>
        </el-dialog>
        <station-ad-setting ref="adSetting" :readOnly="true"></station-ad-setting>
    </div>
</template>

<script>
    import util from '@/utils/util'
    import stationAdSetting from './station-ad-setting'
    export default {
        components: {
            stationAdSetting
        },
        data() {
            return {
                util: util,
                pageParam: null,
                tabledata: [],
                changeTypeDic: [],
                dialogVisible: false,
                changeTableData: [],
                changeContentKeys: {
                    "description": "标的说明",
                    "expectedIncomeRatio": "预期收益比例",
                    "investCompanyName": "资方公司",
                    "investIncomeDetails": "分成比例",
                    "isExpectedIncome": "是否开启预期收益",
                    "operateCompanyName": "运营商",
                    "propertyMonth": "资产有效期",
                    "protocolUrl": "协议附件",
                    "startDate": "生效日期",
                    "targetName": "标的名称"
                },
                operateTypeDic: [
                    {
                        label: '商户临时关闭广告',
                        value: '1'
                    },
                    {
                        label: '平台设置广告',
                        value: '2'
                    }
                ]
            }
        },
        props:['stationId'],
        watch: {
            stationId: {
                handler (val) {
                    if(this.pageParam) {
                        this.pageParam.freshCtrl++
                    }else {
                        this.pageParam = {
                            url: this.$Config.apiUrl.stationAdAuthRecordPageVoPage,
                            method: "post",
                            params: {
                                "stationId": val
                            },
                            freshCtrl: 1,
                        }
                    }
                }
            }
        },
        mounted () {
        },
        methods:{
            handleRefresh () {
                this.pageParam.freshCtrl++
            },
            setTableData (datas) {
                this.tabledata = datas
            },
            showChangeContent (row) {
                try {
                    let datas = JSON.parse(row.currentJson)
                    this.$refs['adSetting'].form = {
                        ...datas,
                        authList: datas.adList,
                        adReStartTime: datas.adReStartTime ? this.$getDay.getTimeStampToStr(datas.adReStartTime, 'YYYY-MM-DD') : ''
                    }
                    this.$refs['adSetting'].dialogVisible = true
                    
                    return
                    let changeContent = JSON.parse(row.afterJson)
                    let changeContentOld = JSON.parse(row.beforeJson)
                    console.log(changeContent, changeContentOld);
                    let changeTableData = []
                    for (const key in this.changeContentKeys) {
                        if (Object.hasOwnProperty.call(this.changeContentKeys, key)) {
                            let newVal = changeContent[key] || '', oldVal = changeContentOld[key] || ''
                            if(key == 'isExpectedIncome') {
                                newVal = newVal == 1 ? '是' : '否'
                                oldVal = oldVal == 1 ? '是' : '否'
                            }
                   
                            let isChange = changeContent[key] == changeContentOld[key] ? false : true
                            if(key == 'investIncomeDetails') {
                                if(newVal.length != oldVal.length) {
                                    isChange = true
                                }else {
                                    isChange = this.arraysEqual(newVal, oldVal)
                                }
                            }
                            if(key == 'expectedIncomeRatio') {
                                newVal = newVal ? this.$decimal.decimal_ride(newVal, 100) + '%' : '-'
                                oldVal = oldVal ? this.$decimal.decimal_ride(oldVal, 100) + '%' : '-'
                            }
                            changeTableData.push({
                                changeItemName: this.changeContentKeys[key],
                                keyVal: key,
                                newVal: newVal,
                                oldVal: oldVal,
                                isChange: isChange
                            })
                        }
                    }
                    this.changeTableData = changeTableData.filter(res=>{
                        return res.isChange
                    })
                    this.dialogVisible = true
                } catch (error) {
                    this.$message.error('解析失败')
                    console.log(error);
                }
                
            },
            arraysEqual (arr1, arr2) {
                for (let index = 0; index < arr1.length; index++) {
                    const item = arr1[index];
                    let targetItem = arr2.find(res=>{
                        return res.companyId == item.companyId && res.ratio == item.ratio && res.payCompany == item.payCompany
                    })
                    if(!targetItem) {
                        return(true)
                    }
                }
                return false
            },
        }
    }
</script>

<style lang="scss" scoped>
.underlying-child-content{
    padding: 20px 20px;
    position: relative;
    .line{
        height: 10px;
        background: #f5f7fa;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
    }
}
</style>